import Tooltip from 'rc-tooltip'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { CloseWhiteIcon } from '../Icons/svg/index'

const MODAL_ROOT =
  'modal fade show fixed inset-0 z-[1055] flex items-center justify-center h-full w-full overflow-x-hidden overflow-y-auto outline-none'

const MODAL_DIALOG =
  'max-w-[800px] relative mx-auto mb-4 mt-14 flex align-center w-[calc(100%-2rem)] items-center min-h-[calc(100%-5rem)]'

const MODAL_CONTENT =
  'pointer-events-auto relative flex w-full flex-col rounded-lg border-0 bg-[var(--gray-90)] text-white'

const MODAL_BODY =
  'px-5 py-[1.875rem] max-[1200px]:px-4 max-[1200px]:py-6'

const BTN_CLOSE =
  'absolute right-3 top-3 z-[1] flex h-6 max-w-6 w-6 cursor-pointer items-center justify-center rounded-full border-2 border-solid border-[var(--gray-90)] bg-[var(--gray-60)] p-0 opacity-100 shadow-none hover:opacity-100 [&_svg]:h-2.5 [&_svg]:w-2.5'

const CommonPopup = (props) => {
  const {
    children,
    modalCloseHandler,
    classes,
    id,
    modalBodyClasses,
    modalDialogClass,
    modalContentClass,
    hideCloseButton
  } = props
  const { t } = useTranslation()

  useEffect(() => {
    const body = document.body
    body?.classList.add('overflowHidden')
    return () => {
      body?.classList.remove('overflowHidden')
    }
  }, [])

  return (
    <div
      className={`${MODAL_ROOT} ${classes || ''}`.trim()}
      style={{ display: 'block' }}
      id={id}
      onClick={modalCloseHandler}
    >
      <div className={`${MODAL_DIALOG} ${modalDialogClass || ''}`.trim()}>
        <div
          className={`${MODAL_CONTENT} ${modalContentClass || ''}`.trim()}
          onClick={(e) => e.stopPropagation()}
        >
          {!hideCloseButton &&
            <Tooltip
              placement='bottomRight'
              trigger={['hover']}
              overlayStyle={{ fontSize: '0.7rem', zIndex: 9999 }}
              overlay={<span>{t('close')}</span>}
              showArrow={false}
            >
              <button
                type='button'
                className={BTN_CLOSE}
                onClick={modalCloseHandler}
              >
                <CloseWhiteIcon />
              </button>
            </Tooltip>}
          <div className={`${MODAL_BODY} ${modalBodyClasses || ''}`.trim()}>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CommonPopup
